import {birdsData} from "./birds-data.js";
import {birdsObjectsIndex, getRandomIntInclusive} from "./random.js";
import {createNextQuestion, choseSoundCategory} from './next-question.js';
import {addScore} from './score.js';
import { range, audio, imgSrc, pauseAudio } from "./audioplayer.js";
import { findCurrentActiveQuestion } from "./question.js";

const arrayVariant = document.querySelectorAll('.chose-answer__variant-text'),
      questionAudio = document.getElementById('questionAudio'),
      birdName = document.querySelector('.bird-data__h3'),
      birdImage = document.querySelector('.current-question__image');

let arrayBirdsName = [];
let arrayListBird = [];
let counterScore = 5;
let counterScoreText = document.querySelector('.bird-data__span-score');

function reformArraysForCheckAnswer() {
  arrayBirdsName = [];
  arrayListBird = [];
  for (let matrixString = 0; matrixString < birdsData.length; matrixString++) {
    for (let matrixColumn = 0; matrixColumn < birdsData[matrixString].length; matrixColumn++) {
      arrayBirdsName.push(birdsData[matrixString][matrixColumn].name);
      arrayListBird.push(birdsData[matrixString][matrixColumn]);
    }
  }
}

reformArraysForCheckAnswer();
if (arrayVariant.length !== 0) {
  choseSoundCategory();
  
  for (let name of arrayVariant) {
    name.addEventListener('click', () => {
      const clickedBirdName = name.textContent;
      variantCheck(clickedBirdName, name);
    })
  }
}

function variantCheck (clickedBirdName, name) {
  // console.log("called variant check");
  // console.log(arrayBirdsName);
  for (let index = 0; index < arrayBirdsName.length; index++) {
    if (clickedBirdName == arrayBirdsName[index]) {
      let clickedAudio = arrayListBird[index].audio;
      for (let i = 0; i < arrayVariant.length; i++) {
        if (arrayVariant[i].classList.contains('chose-answer__variant_right-answer')) {
          return;
        }
      }
      if (clickedAudio.includes("http")) {
        if (clickedAudio == questionAudio.src) {
          rightAnswer (name);
          birdName.innerHTML = arrayListBird[index].name;
          birdImage.src = arrayListBird[index].image;
        }
        if (clickedAudio != questionAudio.src) {
          // console.log(clickedAudio + " clicked audio")
          // console.log(questionAudio.src + " question audio src")
          wrongAnswer (name);
        }
      } else {
        if (questionAudio.src.includes(clickedAudio.slice(1))) {
          rightAnswer (name);
          birdName.innerHTML = arrayListBird[index].name;
          birdImage.src = arrayListBird[index].image;
        } else {
          wrongAnswer (name);
        }
      }
    }
  }
}

function rightAnswer (name) {
  pauseAudio (imgSrc, audio);
  addScore ();
  name.classList.add('chose-answer__variant_right-answer');
  name.previousElementSibling.classList.add('chose-answer__input-radio_right-answer');
  counterScoreText.textContent = `${counterScore + +counterScoreText.textContent}`;
  localStorage.setItem('score', counterScoreText.textContent);
  counterScore = 5;
  soundRightAnswer ()
  createNextQuestion ();
}


function wrongAnswer (name) {
    name.classList.add('chose-answer__variant_wrong-answer');
    name.previousElementSibling.classList.add('chose-answer__input-radio_wrong-answer');
    counterScore -= 1;
    soundWrongAnswer ();
}

function soundWrongAnswer () {
  let soundWrong = new Audio();
  soundWrong.preload = 'auto';
  soundWrong.src = './assets/sound/qiuz-page/incorrect-sound/05-hmm1-100049.mp3';
  soundWrong.play();
  soundWrong.volume = range.value / 100;
}

function soundRightAnswer () {
  let soundRight = new Audio();
  soundRight.preload = 'auto';
  soundRight.src = './assets/sound/qiuz-page/correct-sound/aaahhhhhh-125821.mp3';
  soundRight.play();
  soundRight.volume = range.value / 100; 
}

function loadCurrentBirdsFromActualLang() {
  let indexOfCategory = findCurrentActiveQuestion();
  console.log("current active is " + indexOfCategory);
  for (let i = 0; i < arrayVariant.length; i++) {
    arrayVariant[i].textContent = birdsData[indexOfCategory][+arrayVariant[i].getAttribute("id") - 1].name;
  }
}



export {birdImage, birdName, arrayVariant, reformArraysForCheckAnswer, loadCurrentBirdsFromActualLang};